import { Tooltip, Button, Grid, IconButton } from "@mzc-pdc/ui";
import { IconCancel } from "@mzc-cloudplex/icons";
import theme from "@styles/theme";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";

export const PageHeader = ({ breadcrumb, prev, title, hideInfo, info, actions, sx }) => {
    const { t } = useTranslation();
    return (
        <>
            {breadcrumb}
            <Grid container flexDirection={"row"} flexWrap={"nowrap"} sx={sx}>
                <Grid item xs mr={1} sx={{ overflow: "hidden", minWidth: 0 }}>
                    <Grid container mt={0.75} mb={1.5} flexWrap={"nowrap"} alignItems={"stretch"}>
                        {prev && (
                            <Grid item sx={{ maxHeight: "50px", mt: 1, flexShrink: 0 }}>
                                {prev}
                            </Grid>
                        )}
                        <Grid container alignItems={"center"} sx={{ flex: 1, overflow: "hidden", minWidth: 0 }}>
                            {title && (
                                <Grid item sx={{ flex: 1, overflow: "hidden", minWidth: 0 }}>
                                    {title}
                                </Grid>
                            )}
                            {prev && !hideInfo && !!info && (
                                <Button
                                    variant={"solid"}
                                    color={"primary"}
                                    sx={{ minWidth: 0, ml: 1.5, flexShrink: 0 }}
                                >
                                    {t(`common::label::Info`, `Info`)}
                                </Button>
                            )}
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item sx={{ mt: 0.75, minWidth: "fit-content", flexShrink: 0 }}>
                    {actions && (
                        <Grid item sx={{ minWidth: "fit-content", flexShrink: 0 }}>
                            {actions}
                        </Grid>
                    )}
                </Grid>
            </Grid>
        </>
    );
};

export const CustomMenuPageHeader = ({ prev, title, hideInfo, info, actions, sx }) => {
    const { t } = useTranslation();
    const history = useHistory();
    return (
        <>
            <Grid container flexDirection={"row"} flexWrap={"nowrap"} sx={sx} px={3.5}>
                <Grid item xs mr={1} sx={{ overflow: "hidden", minWidth: 0 }}>
                    <Grid container my={"7px"} flexWrap={"nowrap"} alignItems={"stretch"}>
                        {prev && (
                            <Grid item sx={{ maxHeight: "40px", pt: "5px", flexShrink: 0 }}>
                                {prev}
                            </Grid>
                        )}
                        <Grid container alignItems={"center"} sx={{ flex: 1, overflow: "hidden", minWidth: 0 }}>
                            {title && (
                                <Grid item sx={{ flex: 1, overflow: "hidden", minWidth: 0 }}>
                                    {title}
                                </Grid>
                            )}
                            {prev && !hideInfo && !!info && (
                                <Button
                                    variant={"solid"}
                                    color={"primary"}
                                    sx={{ minWidth: 0, ml: 1.5, flexShrink: 0 }}
                                >
                                    {t(`common::label::Info`, `Info`)}
                                </Button>
                            )}
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item sx={{ display: "flex", py: 1.5, minWidth: "fit-content", flexShrink: 0 }}>
                    {actions && <Grid item>{actions}</Grid>}
                    <Tooltip title={t(`common::label::Close`, `Close`)}>
                        <IconButton
                            size="large"
                            circled
                            onClick={(e) => {
                                e.stopPropagation();
                                history.goBack();
                            }}
                            sx={{ ml: 1.5 }}
                        >
                            <IconCancel size={20} htmlColor={theme.palette.greySecondary.main} />
                        </IconButton>
                    </Tooltip>
                </Grid>
            </Grid>
        </>
    );
};
